<div class="impersonated">
    <div class="row container impersonated__wrapper impersonated__image">
        <div class="col-md-12 col-xs-12">
            <div class="impersonated__header">
                <img src="assets/images/logo-160-x-64.svg" alt="logo-sc" class="impersonated__header__image">
            </div>
        </div>
    </div>

    <div class="row container impersonated__wrapper">
        <div class="col-md-6 offset-md-3 col-xs-12">
            <div class="impersonated__form-wrapper">
                <div class="impersonated__form-wrapper__tab-header">
                    <sc-tab [items]="tabs" [selectedItem]="selectedItem" (selectedTabToEmit)="selectTab($event)">
                    </sc-tab>
                </div>
                <div [ngSwitch]="selectedItem.id">
                    <form [formGroup]="producerForm" *ngSwitchCase="'Tab1'">
                        <div class="impersonated__form-wrapper__tab-container">
                            <div class="d-flex">
                                <div class="impersonated__form-wrapper__tab-container__branch-select">
                                    <sc-select placeholder="" formControlName="branchCode" [label]="'Casa'"
                                        [items]="branches" [enableSearch]="false"></sc-select>
                                </div>
                                <div class="impersonated__form-wrapper__tab-container__producer-input">
                                    <sc-input [debounceTime]="100" [type]="'number'" formControlName="producerCode" label="N° Productor"
                                        placeholder="Ej.: 2012" [errorMessages]="producerCodeErrors"
                                        [icon]="loadingUsernames? 'loading' : null">
                                    </sc-input>
                                </div>
                            </div>
                            <div>
                                <sc-select [isDisabled]="isUserDisabled"
                                    placeholder="Seleccioná el usuario" formControlName="username" [debounceTime]="100"
                                    [label]="'Usuarios'" [itemsAsync$]="usernames$" [enableSearch]="false">
                                </sc-select>
                            </div>
                        </div>
                        <div>
                            <sc-button class="impersonated__form-wrapper__button" id="login-producer" type="primary"
                                (onClick)="loginUsernameByProducerCode()"
                                [disabled]="loadingLogin || !producerForm.valid" [loading]="loadingLogin"> Ingresar
                            </sc-button>
                        </div>
                    </form>
                    <form [formGroup]="usernameForm" *ngSwitchCase="'Tab2'">
                        <div class="impersonated__form-wrapper__tab-container">
                            <sc-input [debounceTime]="100" formControlName="username" label="Usuario"
                                placeholder="Escribí un usuario" [errorMessages]="usernameErrors">
                            </sc-input>
                        </div>
                        <div>
                            <sc-button class="impersonated__form-wrapper__button" [disabled]="!usernameForm.valid"
                                size="large" id="login-username" type="primary" [loading]="loadingLogin"
                                (onClick)="loginUsername(usernameForm.controls.username.value)">
                                Ingresar
                            </sc-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
